<style>
.login-box {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.login-header {
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>
<template>
<v-card class='login-box elevation-23 bg'>
  <v-progress-linear
    v-show='loading'
    :indeterminate="true"
    :height='3' >
  </v-progress-linear>
  <v-card-title >
    <img class='login-header' width='330' height='80' src='https://s3.eu-central-1.amazonaws.com/static.appointmentguru.co/images/logo.png' />
  </v-card-title>
  <request-status
    v-if="requests.start.status!==401"
    :request="requests.start"
    :message200="false" />
  <v-card-text v-if='status !== states.LOGIN' class='text-xs-center' >
    <v-progress-circular :size="70" color='amber' indeterminate >
    </v-progress-circular>
    <h1 class='headline mt-4' >{{statusMessage}}</h1>
    <v-card-actions
      v-if="requests.start.status === 500"
      style='background-color:white;border-top:solid 1px #ccc;'>
      Login request failed. Try again?
      <v-spacer></v-spacer>
      <v-btn @click='start' :loading="requests.start.loading" color="primary">Retry</v-btn>
    </v-card-actions>
  </v-card-text>
  <v-card-text v-else >
    <!-- login -->
    <v-window v-model="step" vertical >
      <v-window-item >

        <request-status
          :request="requests.login"
          :message200="false"
          message401="Authentication failed. Invalid username or password" />

          <v-layout row>
          <v-flex xs12>
            <v-text-field box
              name="id-username"
              id="id-username"
              v-model='username'
              @keypress.enter='login'
              label='Your e-mail address'
              persistent-hint >
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <v-text-field  box
              name="id-password"
              type='password'
              @keypress.enter='login'
              v-model='password'
              label='Password'
              persistent-hint >
            </v-text-field>
          </v-flex>
        </v-layout>

        <v-card-actions style='background-color:white;border-top:solid 1px #ccc;'>
          <v-btn @click="prepareLinkPage" flat>Send me a login link</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click='login' :disabled="loading" color="primary">Login</v-btn>
        </v-card-actions>
      </v-window-item >

      <!-- OTP-->
      <v-window-item>
        <request-status :request="requests.requestOTP" />
        <v-alert v-if="requests.login.status === 401" :value="true" >
          The code you entered is incorrect or has expired
        </v-alert>

        <v-layout row v-if="requests.requestOTP.status != 200" >
          <v-flex xs8 >
            <v-text-field box
              name="id-email"
              id="id-email"
              v-model='email'
              type="email"
              label='Your e-mail address'
              hint="If you have an account, we will send an code to this email which you can enter below"
              persistent-hint >
            </v-text-field>
          </v-flex>
          <v-flex xs4 >
            <v-btn @click="sendOTP" color="primary" class="mt-2" :disabled="!email" >Send code</v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-else row>
          <v-flex xs12 >

            <v-text-field box
              name="id-code"
              id="id-code"
              v-model='code'
              label='Type your code in here'
              hint="We sent it to your email address. Check your SPAM folder if you can't see it"
              persistent-hint >
            </v-text-field>

            <v-btn @click="sendOTP" flat >Resend code</v-btn>

          </v-flex>
        </v-layout>
      </v-window-item >
    </v-window>
  </v-card-text>



  <v-card-actions v-if="step===1" style='background-color:white;border-top:solid 1px #ccc;'>
    <v-btn @click="step=0" flat>Back to login</v-btn>
    <v-spacer></v-spacer>
    <v-btn @click='login' :disabled="code.length!=4" :loading="loading" color="primary">Verify</v-btn>
  </v-card-actions>

  <!-- <v-btn @click="start" >Set csrf</v-btn>
  <v-btn @click="start('12345')" >Store token</v-btn>
  <v-btn @click="start" >Get token</v-btn> -->

</v-card>
</template>
<script type="text/javascript">
// import axios from 'axios'
import RequestsMixin from '@/mixins/requests'
import { LOGIN, LOGOUT, KONG_TOKEN_KEY } from '@/store/constants'
import {mapGetters} from 'vuex'
import Vue from 'vue'
const STATE = {
  INIT: 0,
  LOGGEDIN: 1,
  LOGIN: 2
}

export default {
  name: 'LoginPage',
  mixins: [RequestsMixin],
  props: {
    withInit: { type: Boolean, default: true }
  },
  data () {
    return {
      step: 0,
      statusMessage: 'Waking the Guru',
      status: 0,
      states: STATE,
      email: '',
      username: '',
      password: '',
      code: '',
      label: 'tests',
      loginResult: {},
      showcode: false,
      alreadyLoggedIn: false,
      requests: {
        start: {
          resource: 'auth.session'
        },
        requestOTP: {
          resource: 'ag.auth'
        },
        login: {
          resource: 'auth.login'
        }
      }
    }
  },
  mounted () {
    if (!this.withInit) {
      this.status = STATE.LOGIN
      return null
    }
    this.status = STATE.INIT
    this.start()
  },
  watch: {
    startStatus () {
      if (this.startStatus === 0) { return null }
      if (this.startStatus === 200) {
        let payload = this.requests.start.result
        this.status = STATE.INIT
        this.statusMessage = 'Logging you in'
        this.$store.dispatch(LOGIN, payload)
        this.getMe()
      } else if (this.startStatus > 299) {
        this.status = STATE.LOGIN
      }
    },
    getMeReqStatus () {
      if (this.getMeReqStatus === 200) {
        this.state = STATE.LOGGEDIN
        this.statusMessage = 'Hi ' + this.$store.getters.me.first_name + '!'
        this.$emit('loggedin')
        this.redirect()
      }
      if (this.getMeReqStatus === 401) {
        this.$store.dispatch(LOGOUT)
      }
      if (this.getMeReqStatus > 200) {
        this.status = STATE.LOGIN
      }
    },
    loginStatus () {
      if (this.loginStatus === 200) {
        this.status = STATE.INIT
        this.statusMessage = 'Logged in. Loading profile'
        this.$store.dispatch(LOGIN, this.requests.login.result)
        this.getMe()
        this.redirect()
      }
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'refreshToken'
    ]),
    loading () { return this.requests.login.loading },
    showLoginMessage () {
      return (this.loginResult.response && this.loginResult.response.data && this.loginResult.response.data.message)
    },
    loginPayload () {
      let data = {
        client_id: this.$env.CLIENT_ID,
        client_secret: this.$env.CLIENT_SECRET
      }
      if (this.step === 0) {
        data.username = this.username
        data.password = this.password
      }
      if (this.step === 1) {
        data.email = this.email
        data.otp = this.code
      }
      return data
    },
    // refreshPayload () {
    //   return {
    //     grant_type: 'refresh_token',
    //     client_id: this.$env.CLIENT_ID,
    //     client_secret: this.$env.CLIENT_SECRET,
    //     refresh_token: this.refreshToken
    //   }
    // },
    otpPayload () {
      return {
        client_id: this.$env.CLIENT_ID,
        client_secret: this.$env.CLIENT_SECRET,
        email: this.email,
        otp: this.otp
      }
    },
    passwordPayload () {
      return {
        password: this.password
      }
    },
    loginStatus () {
      return this.requests.login.status
    },
    startStatus () {
      return this.requests.start.status
    }
  },
  methods: {
    start () {
      let token = Vue.$cookies.get(KONG_TOKEN_KEY)
      let data = {
        client_id: this.$env.CLIENT_ID,
        client_secret: this.$env.CLIENT_SECRET
      }
      if (token) {
        data.token = token
      }
      this.requests.start.data = data
      this.$request('save', this.requests.start)
    },
    prepareLinkPage () {
      this.step = 1
      this.code = ''
      this.requests.login.status = 0
      if (!this.email) { this.email = this.username }
    },
    sendOTP () {
      this.requests.requestOTP.data = {
        email: this.email,
        method: 'email'
      }
      this.requests.requestOTP.extra = 'forgot-password'
      this.$request('save', this.requests.requestOTP)
    },
    login () {
      this.requests.login.data = this.loginPayload
      this.requests.requestOTP.extra = 'forgot-password'
      this.$request('save', this.requests.login)
    },
    redirect () {
      let vm = this
      setTimeout(() => {
        let redirect = vm.$store.getters.loginRedirect
        if (!redirect) { return '/' }
        vm.$router.push(redirect)
      }, 500)
    }

  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?f6b6b6fa